import type { MarkedExtension, Tokens } from 'marked';
import { MarkedRenderer } from 'ngx-markdown';
import { take } from 'rxjs/operators';
import { MarkdownWebApplicationConfigurationService } from '../services/markdown-web-application-configuration.service';

export class MarkdownRenderer extends MarkedRenderer {
  private selfTargetPattern: RegExp | undefined;

  constructor(private markdownWebApplicationConfigurationService: MarkdownWebApplicationConfigurationService) {
    super();

    this.markdownWebApplicationConfigurationService.linkTargetSelfUrlpattern.pipe(take(1)).subscribe((value) => {
      if (value) {
        this.selfTargetPattern = new RegExp(value);
      }
    });
  }

  // marked.use() iterates the renderer's OWN enumerable props, so this must stay a plain
  // object of functions — a class instance (data fields, prototype methods) breaks it at runtime
  getMarkedExtension(): MarkedExtension {
    return {
      renderer: {
        link: (token: Tokens.Link): string => {
          const href: string = token.href ?? '';
          const text: string = token.text ?? '';

          if (!href) return ''; // Skip empty links

          const target = this.selfTargetPattern && this.selfTargetPattern.test(href) ? '_self' : '_blank';
          return `<a href="${href}" target="${target}" rel="noopener">${text}</a>`;
        },

        text: (token: Tokens.Text | Tokens.Escape): string => {
          const originalText: string = token.text ?? token.raw ?? '';

          /*
           * Replace :something|cssclass: by a material icon named "something" with the class "cssclass"
           * Example : :warning|warn: will be replaced by <i class="material-icons warn">warning</i>
           */
          const pattern = /:([\w-]+)(\|([\w-]+))?:/g;
          return originalText.replace(pattern, (_match: string, iconName: string, _pipe: string, cssClass: string) => {
            const iconClass = cssClass ? `${cssClass}` : '';
            return `<i class="material-icons ${iconClass}" color="accent">${iconName}</i>`;
          });
        }
      }
    };
  }
}

export default MarkdownRenderer;
